// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import Footer from "../../widgets/Footer";

// Overview page components
import Header from "./components/Header";
import ToastWidget from "widgets/Toast";

import { useEffect, useState } from "react";

import ChangePasswordDialog from "./changePasswordDialog";
import TFADialog from "./tfaDialog";

function Overview() {
  const [uiToast, setUIToast] = useState({
    isShow: false,
    message: "",
  });

  const [changePasswordDialogShow, setChangePasswordDialogShow] = useState({
    show: false,
    data: null,
  });

  const [tfaDialogShow, setTFADialogShow] = useState({
    show: false,
    data: null,
  });

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastWidget
        key="toast"
        isShow={uiToast.isShow}
        message={uiToast.message}
        onClose={() => setUIToast({ isShow: false })}
      />
      <ChangePasswordDialog
        data={changePasswordDialogShow.data}
        show={changePasswordDialogShow.show}
        handleClose={(result) => {
          setChangePasswordDialogShow({
            show: false,
          });
          if (result) {
            setUIToast({
              isShow: true,
              message: "Cập nhật mật khẩu thành công",
            });
          }
        }}
      />
      <TFADialog
        data={tfaDialogShow.data}
        show={tfaDialogShow.show}
        handleClose={(result) => {
          setTFADialogShow({
            show: false,
          });
          if (result) {
            setUIToast({
              isShow: true,
              message: "Cập nhật TFA thành công",
            });
            window.location.reload();
          }
        }}
      />
      <MDBox mb={2} />
      <Header
        onChangePassword={() => {
          setChangePasswordDialogShow({
            show: true,
          });
        }}
        onTfa={(tfa) => {
          setTFADialogShow({
            show: true,
            data: {
              tfa,
            },
          });
        }}
      >
        <MDBox mt={5} mb={3}></MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
